import React, { FunctionComponent } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface ShowTagsProps {
  defaultEnabled: boolean | null;
}

const ShowTags: FunctionComponent<ShowTagsProps> = ({ defaultEnabled }) => (
  <I18nProviderWrapper>
    <SettingsEnableDisable
      defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
      description={bfTranslate('Only applies to assets in Collections and Share Links')}
      errorTitle={bfTranslate('Error updating tags viewing permissions. Please contact support.')}
      id="show-tags"
      successTitle={bfTranslate('Tags viewing permissions updated!')}
      title={bfTranslate('Allow guest and public users to see tags')}
      updateResourceKey="showTags"
    />
  </I18nProviderWrapper>
);

export default ShowTags;
